import { useTranslation } from 'react-i18next';
import aboutImg from '../../Assets/Images/Home/home-about.svg';

export default function AboutUs() {
  const { t } = useTranslation();
  return (
    <section className="home__about">
      <h2>{t('home.about.title')}</h2>
      <div className="home__about-content">
        <div>
          <p>{t('home.about.section1')}</p>
          <p>{t('home.about.section2')}</p>
        </div>
        <img src={aboutImg} alt="About us" loading="lazy" />
      </div>
    </section>
  );
}
